
import Phaser from 'phaser';
import { PLANTS } from '../config/plants';
import { ZOMBIES } from '../config/zombies';
import { ASSETS } from '../config/assets';
import { ANIMATIONS } from '../config/animations';

export default class GameScene extends Phaser.Scene {
    constructor() {
        super({ key: 'GameScene' });
        this.gridSize = 80; // 格子大小
        this.grid = []; // 网格数组，存储每个格子的状态
        this.plants = []; // 植物数组
        this.zombies = []; // 僵尸数组
        this.sunAmount = 100; // 初始阳光数量
        this.selectedPlant = null; // 当前选择的植物
        this.selectedZombie = null; // 当前选择的僵尸
        this.playerRole = null; // 玩家角色：'plants' 或 'zombies'
        this.score = 0; // 玩家得分
        this.animations = {};
        this.projectiles = [];
        this.assetsLoaded = false;
        this.gameElementsCreated = false; // 添加标记
    }

    init(data) {
        this.socket = data.socket;
        this.playerRole = data.role; // 从Game.vue传入角色信息
        this.username = data.username;
        this.setupSocketListeners();
    }

    preload() {
        try {
            // 加载基础图片资源
            this.load.image('sun', 'assets/images/projectiles/sun.png');
            this.load.image('lawn', 'assets/images/background/lawn.jpg');
            this.load.image('selectbar','assets/images/ui/selectbar.png');
            // 加载植物资源（使用 PLANTS 配置进行验证）
            // 加载植物资源
            this.load.image('peashooter','assets/images/plants/peashooter.png');

            // 加载子弹/投射物资源
            this.load.image('pea','assets/images/projectiles/pea.png')

            // 加载UI资源
            //植物卡片，动物卡片
            this.load.image('card','assets/images/cards/peashooter.png')

            // 添加加载完成事件监听
            this.load.on('complete', () => {
                this.assetsLoaded = true;
                this.createGameElements();
            });
        } catch (error) {
            console.error('资源加载失败:', error);
        }
    }
    create() {
        // 如果资源已加载完成，直接创建游戏元素
        if (this.assetsLoaded) {
            this.createGameElements();
        }
        this.createGameElements();
        // 设置游戏区域
        const gameWidth = this.cameras.main.width;
        const gameHeight = this.cameras.main.height;

        // 创建草地
        this.add.image(0,80, 'lawn')
        .setOrigin(0, 0)
        .setDisplaySize(gameWidth, gameHeight - 80);

        // 创建选择卡片区域
        this.add.image(gameWidth / 2, 80, 'selectbar')
        .setOrigin(0.5, 0) // 让图片中心对齐
        .setDisplaySize(gameWidth * 0.6, 50); // 适配游戏宽度

        //植物卡片
        this.add.image(235,82,'card')
        .setOrigin(0,0)
        .setDisplaySize(28,45);
        
        // 创建网格
        this.createLawnGrid();
        this.createSelectionGrid();
    }
    
    
    updatePlantSelection(selectedPlant) {
        this.selectedPlant = selectedPlant;
        // 确保 plantCards 已被初始化
        if (!this.plantCards) {
            console.error('plantCards 未初始化');
            return;
        }
        // 更新植物选择卡片的视觉效果
        this.plantCards.forEach((card) => {
            if (card.type === selectedPlant) {
                card.setTint(0x00ff00); // 选中时变为绿色
            } else {
                card.clearTint(); // 取消选中效果
            }
        });
    }
    // 添加一个方法来检查UI是否已经创建
    isUIReady() {
        return this.plantsScoreText && this.zombiesScoreText;
    }
    // 新增方法：创建游戏元素
    createGameElements() {
        try {

            // 创建动画
            this.createAnimations();

            // 设置socket监听
            this.setupSocketListeners();

            // 标记游戏元素已创建
            this.gameElementsCreated = true;
        } catch (error) {
            console.error('创建游戏元素失败:', error);
        }
    }
    updatePlant(plant) {
        // 处理植物逻辑的占位符
        // 这里可以添加植物的行为逻辑
    }
    createSelectionGrid() {
        this.grid = []; // 初始化网格数组
    
        // 创建 1 行 15 列的网格
        for (let row = 0; row < 1; row++) { // 1 行
            this.grid[row] = []; // 创建行数组
    
            for (let col = 0; col < 13; col++) { // 15 列
                const x = 235 + col *30.2 ;  // 计算 X 坐标
                const y = 80;  // 计算 Y 坐标
    
                // 创建网格单元
                const cell = this.add.rectangle(
                    x, 
                    y, 
                    30.2, // 网格宽度
                    50, // 网格高度
                    0xffffff, // 颜色：白色
                    0.3 // 透明度：30%
                )
                .setStrokeStyle(2, 0x00ff00) // 绿色边框，方便调试
                .setOrigin(0, 0) // 左上角对齐
                .setInteractive(); // 让网格可以点击
    
                // 存储网格信息
                this.grid[row][col] = {
                    x: x,
                    y: y,
                    occupied: false, // 是否被占用
                    cell: cell,
                };
    
                // 监听点击事件
                cell.on('pointerdown', () => {
                    this.handleGridClick(row, col);
                });
            }
        }
    }
    createLawnGrid() {
        this.grid = []; // 初始化网格数组
    
        for (let row = 0; row < 5; row++) { // 5 行
            this.grid[row] = []; // 创建行数组
    
            for (let col = 0; col < 9; col++) { // 9 列
                const x = 145 + col * 45;  // 计算 X 坐标
                const y = 155 + row * 85;  // 计算 Y 坐标
    
                // 创建网格单元
                const cell = this.add.rectangle(
                    x, 
                    y, 
                    45, // 网格宽度
                    85, // 网格高度
                    0xffffff, // 颜色：白色
                    0.3 // 透明度：30%
                )
                .setStrokeStyle(2, 0x00ff00) // 绿色边框，方便调试
                .setOrigin(0, 0) // 左上角对齐
                .setInteractive(); // 让网格可以点击
    
                // 存储网格信息
                this.grid[row][col] = {
                    x: x,
                    y: y,
                    occupied: false, // 是否被占用
                    cell: cell,
                };
    
                // 监听点击事件
                cell.on('pointerdown', () => {
                    this.handleGridClick(row, col);
                });
            }
        }
    }
    
    // 修改显示消息的方法
    showMessage(message) {
        if (!this.assetsLoaded) return; // 如果资源未加载完成，不显示消息

        if (!this.messageText) {
            // 确保 messageText 被初始化
            this.messageText = this.add
                .text(400, 300, message, {
                    fontSize: '32px',
                    fill: '#fff',
                    stroke: '#000',
                    strokeThickness: 4,
                })
                .setOrigin(0.5);
        } else {
            this.messageText.setText(message); // 更新消息文本
        }

        this.time.delayedCall(2000, () => {
            if (this.messageText && this.messageText.active) {
                this.messageText.destroy();
                this.messageText = null; // 清空引用
            }
        });
    }

    setupSocketListeners() {
        this.socket.on('roleSelected', (data) => {
            if (data.role === this.playerRole) {
                // 角色已被选择
                this.showMessage('该角色已被选择');
            }
        });
        // 添加重连处理
        this.socket.on('reconnectSuccess', (data) => {
            if (data.success) {
                this.playerRole = data.role;
                this.score = data.score;
                // 更新游戏状态
                this.updateGameState(data.gameState);
            }
        });
        // 其他玩家断开连接
        this.socket.on('playerDisconnected', (data) => {
            this.showMessage(`玩家 ${data.username} 断开连接`);
        });

        // 其他玩家重新连接
        this.socket.on('playerReconnected', (data) => {
            this.showMessage(`玩家 ${data.username} 重新连接`);
        });

        this.socket.on('gameStart', () => {
            // 游戏开始
            this.startGame();
        });

        // 植物放置同步
        this.socket.on('plantPlaced', (data) => {
            if (this.playerRole === 'zombies') {
                // 只有对方才需要创建
                this.placePlant(data.row, data.col, data.type);
            }
        });

        // 僵尸放置同步
        this.socket.on('zombieSpawned', (data) => {
            if (this.playerRole === 'plants') {
                // 只有对方才需要创建
                this.spawnZombie(data.row, data.type);
            }
        });

        // 阳光数量更新
        this.socket.on('sunAmountUpdate', (data) => {
            if (data.playerId === this.socket.id) {
                this.sunAmount = data.amount;
                this.updateSunDisplay();
            }
        });

        // 分数更新
        this.socket.on('scoreUpdate', (data) => {
            this.updateScore(data.plantsScore, data.zombiesScore);
        });

        // 游戏状态同步
        this.socket.on('gameStateUpdate', (data) => {
            this.updateGameState(data);
        });

        // 游戏时间更新
        this.socket.on('timeUpdate', (data) => {
            this.updateTime(data.timeRemaining);
        });

        // 游戏结束
        this.socket.on('gameOver', (data) => {
            this.handleGameOver(data);
        });
    }

    handleGridClick(row, col) {
        if (this.playerRole === 'plants') {
            if (!this.selectedPlant) return; // 确保已选择植物
            if (this.grid[row][col].occupied) {
                this.showMessage('此格子已被占用');
                return;
            }
    
            // 直接放置植物
            const plantConfig = PLANTS[this.selectedPlant];
            if (this.sunAmount >= plantConfig.cost) {
                // 发送放置事件到服务器
                this.socket.emit('placePlant', {
                    row: row,
                    col: col,
                    type: this.selectedPlant,
                    cost: plantConfig.cost,
                });
    
                // 更新网格状态
                this.grid[row][col].occupied = true; // 更新网格占用状态
                this.sunAmount -= plantConfig.cost; // 扣除阳光
                this.updateSunDisplay(); // 更新阳光显示
    
                // 在网格上放置植物精灵
                const x = this.gridStartX + col * this.gridSize;
                const y = this.gridStartY + row * this.gridSize;
                this.add.sprite(x, y, 'assets/images/cards/peashooter.png').setScale(0.8); // 放置植物
            } else {
                this.showMessage('阳光不足！');
            }
        }
    }

    // 添加选择植物的方法
    selectPlant(type) {
        if (!PLANTS[type]) {
            console.error('Invalid plant type:', type);
            return;
        }
        this.selectedPlant = type;
        // 更新UI显示选中状态
        this.updatePlantSelection(type);
    }

    createPlantSelectionPanel() {
        const startX = 100;
        const startY = 20;
        const padding = 10;
        let currentX = startX;

        Object.entries(PLANTS).forEach(([type, config]) => {
            const card = this.add
                .rectangle(currentX, startY, 70, 90, 0xffffff)
                .setOrigin(0)
                .setInteractive();

            const plantSprite = this.add
                .sprite(currentX + 35, startY + 35, ASSETS.PLANTS[type].key)
                .setScale(0.6);

            const costText = this.add.text(currentX + 5, startY + 70, config.cost.toString(), {
                fontSize: '16px',
                fill: '#000',
            });

            card.on('pointerdown', () => this.selectPlant(type));
            currentX += card.width + padding;
        });
    }

    placePlant(row, col, type) {
        if (!this.assetsLoaded) return null;

        // 获取资源配置
        const assetConfig = ASSETS.PLANTS[type];
        if (!assetConfig) {
            console.error('Missing asset config for plant type:', type);
            return null;
        }

        // 计算位置
        const plantConfig = PLANTS[type]; // 获取植物配置
        if (!plantConfig) {
            console.error(`植物类型 ${type} 的配置未找到`);
            return;
        }

        const x = this.gridStartX + col * this.gridSize;
        const y = this.gridStartY + row * this.gridSize;

        // 创建植物精灵
        const plant = {
            sprite: this.add.sprite(x, y, plantConfig.assetKey), // 使用正确的资产键
            type: type,
            health: plantConfig.health,
            row: row,
            col: col,
            config: plantConfig // 将配置存储在植物对象中
        };
        // 设置精灵属性
        plant.sprite.setOrigin(0.5);
        plant.sprite.setScale(0.8); // 调整大小

        // 如果是向日葵，启动阳光生产
        if (type === 'SUNFLOWER') {
            this.startSunProduction(plant);
        }

        // 如果是射手类植物，启动攻击
        if (type === 'PEASHOOTER') {
            this.startPlantAttack(plant);
        }

        // 将植物添加到数组
        this.plants.push(plant);
        this.grid[row][col].occupied = true;

        return plant;
    }

    spawnZombie(row, type = 'BASIC') {
        if (!this.assetsLoaded) return null;

        const zombieConfig = ZOMBIES[type];
        const assetConfig = ASSETS.ZOMBIES[type];

        if (!zombieConfig || !assetConfig) {
            console.error('Invalid zombie type:', type);
            return null;
        }

        const y = row * this.gridSize + this.gridSize / 2;
        const x = 800; // 从右侧生成

        const zombie = {
            sprite: this.add.sprite(x, y, assetConfig.key),
            type: type,
            health: zombieConfig.health,
            damage: zombieConfig.damage,
            speed: zombieConfig.speed,
            row: row,
            state: 'walking',
        };

        // 设置精灵属性
        zombie.sprite.setOrigin(0.5);
        zombie.sprite.setScale(0.8);

        // 播放行走动画
        const walkAnim = ANIMATIONS.ZOMBIES[type].walk;
        if (walkAnim) {
            zombie.sprite.play(walkAnim.key);
        }

        // 添加物理属性
        this.physics.world.enable(zombie.sprite);
        zombie.sprite.body.setVelocityX(-zombieConfig.speed);

        this.zombies.push(zombie);
        return zombie;
    }

    // 添加僵尸生成逻辑
    startZombieSpawning() {
        if (this.playerRole !== 'zombies') return;

        this.time.addEvent({
            delay: 5000, // 每5秒
            callback: () => {
                if (this.gameStarted) {
                    const row = Phaser.Math.Between(0, 4); // 随机选择行
                    const zombie = this.spawnZombie(row, 'BASIC');
                    if (zombie) {
                        this.socket.emit('zombieSpawned', {
                            row: row,
                            type: 'BASIC',
                        });
                    }
                }
            },
            loop: true,
        });
    }
    // 更新显示
    updateSunDisplay() {
        if (this.sunText) {
            this.sunText.setText(`阳光: ${this.sunAmount}`);
        }
    }

    updateScore(plantsScore, zombiesScore) {
        if (!this.plantsScoreText || !this.zombiesScoreText) {
            console.warn('Score text not initialized');
            return;
        }

        try {
            this.plantsScoreText.setText(`植物: ${plantsScore}`);
            this.zombiesScoreText.setText(`僵尸: ${zombiesScore}`);
        } catch (error) {
            console.error('Error updating score:', error);
        }
    }

    exitGame() {
        // 发送退出消息给服务器
        this.socket.emit('leaveGame');
        // 返回大厅
        window.location.reload();
    }
    update() {
        // 使用 plant 和 zombie 参数或移除它们
        this.plants.forEach((plant) => {
            // 处理植物逻辑
            this.updatePlant(plant);
        });

        this.zombies.forEach((zombie) => {
            // 处理僵尸逻辑
            this.updateZombie(zombie);
        });
        // 检查碰撞
        this.checkCollisions();

        // // 生成阳光
        // if (Phaser.Math.Between(1, 300) === 1) {
        //     this.createSun();
        // }

        // 更新僵尸位置
        this.updateZombies();
    }

    checkCollisions() {
        // 检查植物和僵尸的碰撞
        for (const plant of this.plants) {
            for (const zombie of this.zombies) {
                if (plant.row === zombie.row) {
                    const distance = Math.abs(plant.sprite.x - zombie.sprite.x);
                    if (distance < this.gridSize) {
                        // 发生碰撞
                        this.handleCollision(plant, zombie);
                    }
                }
            }
        }
    }

    handleCollision(plant, zombie) {
        // 处理碰撞逻辑
        // 这里可以添加攻击动画和伤害计算
    }
    createAnimations() {
        if (!this.assetsLoaded) return;
        // 确保 this.anims 存在
        if (!this.anims) {
            console.error('动画系统未初始化');
            return;
        }
        // 清除现有动画
        this.anims.removeAll(); // 使用 destroy 替代 removeAll

        // 创建植物动画
        Object.entries(ANIMATIONS.PLANTS).forEach(([plantType, animations]) => {
            Object.entries(animations).forEach(([_, config]) => {
                if (!this.anims.exists(config.key)) {
                    try {
                        this.anims.create({
                            key: config.key,
                            frames: this.anims.generateFrameNumbers(ASSETS.PLANTS[plantType].key, {
                                start: config.frames.start,
                                end: config.frames.end,
                            }),
                            frameRate: config.frameRate,
                            repeat: config.repeat,
                        });
                    } catch (error) {
                        console.error(`创建动画失败: ${config.key}`, error);
                    }
                }
            });
        });

        // 创建僵尸动画
        Object.entries(ANIMATIONS.ZOMBIES).forEach(([zombieType, animations]) => {
            Object.entries(animations).forEach(([_, config]) => {
                if (!this.anims.exists(config.key)) {
                    try {
                        this.anims.create({
                            key: config.key,
                            frames: this.anims.generateFrameNumbers(
                                ASSETS.ZOMBIES[zombieType].key,
                                {
                                    start: config.frames.start,
                                    end: config.frames.end,
                                }
                            ),
                            frameRate: config.frameRate,
                            repeat: config.repeat,
                        });
                    } catch (error) {
                        console.error(`创建动画失败: ${config.key}`, error);
                    }
                }
            });
        });

        // 创建特效动画
        if (!this.anims.exists('splash')) {
            this.anims.create({
                key: 'splash',
                frames: this.anims.generateFrameNumbers('splash', {
                    start: 0,
                    end: 3,
                }),
                frameRate: 12,
                repeat: 0,
            });
        }
    }

    
    setupSocketListeners() {
        this.socket.on('sunCreated', (data) => {
            this.addSun(data.x, data.y);
        });
    }
    
    addSun(x, y) {
        const sun = this.add.image(x, y, 'sun').setInteractive();
        this.physics.add.existing(sun);
        sun.body.setVelocityY(50);
    
        sun.on('pointerdown', () => {
            if (sun.active) {
                this.sunAmount += 25; // 增加阳光数量
                this.updateSunDisplay(); // 更新阳光显示
                sun.destroy(); // 摧毁阳光图标
                // 通知服务器阳光被收集
                this.socket.emit('sunCollected', {role : this.playerRole, amount: 25} );
            }
        });
    }
    startSunProduction(plant) {
        this.time.addEvent({
            delay: plant.config.cooldown,
            callback: () => {
                if (plant.sprite.active) {
                    // this.createSun(plant.sprite.x, plant.sprite.y);
                    this.startSunProduction(plant);
                }
            },
            callbackScope: this,
        });
    }

    // 选择僵尸
    selectZombie(zombieType) {
        this.selectedZombie = zombieType;
        this.selectedPlant = null;
    }

    // 开始游戏
    startGame() {
        // 清除角色选择界面
        this.children.getAll().forEach((child) => {
            if (child.type === 'Text') {
                child.destroy();
            }
        });
        if (this.playerRole === 'zombies') {
            this.startZombieSpawning();
        }
        // 创建植物选择面板（仅对植物方显示）
        if (this.playerRole === 'plants') {
            this.createPlantSelectionPanel();
        }

        // 初始化游戏状态
        this.gameStarted = true;
        this.createSelectionPanel();
    }

    // 更新僵尸
    updateZombies() {
        this.zombies.forEach((zombie) => {
            if (zombie.state === 'walking' && zombie.sprite.active) {
                // 检查是否到达房子
                if (zombie.sprite.x < 100) {
                    this.handleZombieReachedHouse(zombie);
                }
            }
        });
    }

    // 僵尸到达房子
    handleZombieReachedHouse(zombie) {
        // 游戏结束逻辑
        this.socket.emit('gameOver', { winner: 'zombies' });
        zombie.sprite.destroy();
    }
    updateGameState(gameState) {
        if (!gameState) return;

        try {
            // 清除现有状态
            this.plants.forEach((plant) => {
                if (plant.sprite) plant.sprite.destroy();
            });
            this.zombies.forEach((zombie) => {
                if (zombie.sprite) zombie.sprite.destroy();
            });
            this.plants = [];
            this.zombies = [];

            // 重新创建植物
            if (gameState.plants && Array.isArray(gameState.plants)) {
                gameState.plants.forEach((plantData) => {
                    try {
                        this.placePlant(plantData.row, plantData.col, plantData.type);
                    } catch (error) {
                        console.error('Error placing plant:', error);
                    }
                });
            }

            // 重新创建僵尸
            if (gameState.zombies && Array.isArray(gameState.zombies)) {
                gameState.zombies.forEach((zombieData) => {
                    try {
                        const zombie = this.spawnZombie(zombieData.row, zombieData.type);
                        if (zombie && zombie.sprite) {
                            zombie.sprite.x = zombieData.x;
                            zombie.sprite.y = zombieData.y;
                            zombie.health = zombieData.health;
                            zombie.state = zombieData.state;
                            zombie.id = zombieData.id;
                        }
                    } catch (error) {
                        console.error('Error spawning zombie:', error);
                    }
                });
            }

            // 更新阳光数量
            if (gameState.sunAmount !== undefined && this.sunText) {
                this.sunAmount = gameState.sunAmount;
                this.sunText.setText(`阳光: ${this.sunAmount}`);
            }

            // 更新分数
            if (
                gameState.plantsScore !== undefined &&
                gameState.zombiesScore !== undefined &&
                this.plantsScoreText &&
                this.zombiesScoreText
            ) {
                this.updateScore(gameState.plantsScore, gameState.zombiesScore);
            }
        } catch (error) {
            console.error('Error updating game state:', error);
        }
    }
    // 更新时间显示
    updateTime(timeRemaining) {
        if (!this.timeText) return; // 添加检查

        const minutes = Math.floor(timeRemaining / 60);
        const seconds = timeRemaining % 60;
        this.timeText.setText(`时间: ${minutes}:${seconds.toString().padStart(2, '0')}`);
    }

    // 处理游戏结束
    handleGameOver(data) {
        const winner = data.winner;
        const message = winner === this.playerRole ? '你赢了！' : '你输了！';
        this.showMessage(message);
        // 显示最终分数
        this.updateScore(data.plantsScore, data.zombiesScore);
        // 停止所有游戏逻辑
        this.gameStarted = false;
    }
}
